module.exports = __webpack_public_path__ + "static/media/160-st-vincent-and-the-grenadines.ce571fec.svg";